const alternatePaymentMethodsCacheKey = ({
  accountId,
  accountIdType
}) => ["alternatePaymentMethods", { accountId, accountIdType }];
export {
  alternatePaymentMethodsCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
